import { useTranslation } from 'react-i18next';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { copyText } from './CopyLink';

/**
 * A block of code to copy and paste (DX-1: the key dialog, /developers).
 * Monospace, scrolls sideways instead of widening the page, one copy button.
 */
export function CodeBlock({ code, label, testId }: { code: string; label: string; testId?: string }) {
  const { t } = useTranslation(['common']);
  const onCopy = async () => {
    if (await copyText(code)) toast.success(t('common:codeBlock.copied'));
    else toast.error(t('common:codeBlock.copyFailed'));
  };
  return (
    <div className="relative min-w-0 rounded-md border" style={{ borderColor: 'var(--vf-border)', background: 'var(--vf-surface-2)' }}>
      <div className="flex items-center justify-between border-b px-3 py-1" style={{ borderColor: 'var(--vf-border)' }}>
        <span className="text-[11px] font-medium" style={{ color: 'var(--vf-text-3)' }}>{label}</span>
        <button
          type="button"
          className="inline-flex h-9 min-w-9 items-center justify-center gap-1 rounded px-2 text-[12px] hover:bg-[var(--vf-surface-3)]"
          aria-label={t('common:codeBlock.copyAria', { label })}
          onClick={() => void onCopy()}
        >
          <Copy className="h-3.5 w-3.5" aria-hidden />
          <span>{t('common:codeBlock.copy')}</span>
        </button>
      </div>
      <pre className="overflow-x-auto px-3 py-2 text-[12px] leading-relaxed" data-testid={testId}><code>{code}</code></pre>
    </div>
  );
}
